/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/


import axiosInstance from '../axiosInstance'
 
const getUserMe = param => {
  return axiosInstance.get(`/user/me`, param).then(res => res.data)
}
const getUserById = (userid) => {
  return axiosInstance.get(`/user/{userId}?id=`+userid).then(res => res.data)
}
const patchPassword = param => {
  return axiosInstance.patch(`/user/me/password`, param).then(res => res.data)
}

const patchUserMe = param => {
  return axiosInstance.patch(`/user/me`, param).then(res => res.data)
}
 
export { 
  getUserMe,
   patchPassword,
  patchUserMe, 
  getUserById
}
